import { Component, OnInit } from '@angular/core';
import _, {map} from 'underscore';
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  givenName = '';
  familyName = '';
  email = '';
  password = '';

  register = () => {
    alert(JSON.stringify(_.omit(this, 'register', '__ngContext__' , '__proto__')));
  }
  constructor() { }

  ngOnInit(): void {
  }

}
